module.exports = __webpack_public_path__ + "img/form-bg--991.1ab9e60.webp";